import { Box, type IconTick } from 'braid-design-system';
import type React from 'react';

import { sortDesktopFeatures } from 'src/data/listing-products/desktop';
import {
  getProductInfo,
  type ListingProductWithPackageInfo,
} from 'src/data/listing-products/shared';

import SelectButton from '../SelectButton/SelectButton';

import FeatureCell from './components/FeatureCell/FeatureCell';
import FeatureCellContent from './components/FeatureCellContent/FeatureCellContent';

interface DesktopFeatureProps {
  product: ListingProductWithPackageInfo;
}

const DesktopFeatures = ({ product }: DesktopFeatureProps) => {
  const productInfo = getProductInfo(product);
  const sortedFeatures = sortDesktopFeatures(productInfo.features.desktop);

  return (
    <Box style={{ zIndex: 1 }}>
      {sortedFeatures.map(([feature, featureConfig], i) => {
        const background: BoxBackground =
          i % 2 === 0 ? 'neutralLight' : 'surface';

        return (
          <FeatureCell key={feature} background={background}>
            <FeatureCellContent featureConfig={featureConfig} />
          </FeatureCell>
        );
      })}

      <FeatureCell background="surface">
        <Box display="flex" height="full" alignItems="center">
          <SelectButton product={product} />
        </Box>
      </FeatureCell>
    </Box>
  );
};

type BoxBackground = React.ComponentProps<typeof Box>['background'];
export type IconTone = React.ComponentProps<typeof IconTick>['tone'];

export default DesktopFeatures;
